module.exports = __webpack_public_path__ + "img/circle-y.824118d0.svg";